import AddIcon from "@mui/icons-material/Add";
import Logger from "../../../services/Logger";
import InfoIcon from "@mui/icons-material/Info";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import React, { useState } from "react";
import DatamuseService from "../../../services/DatamuseService";

export default function DatamuseWildcard({ callback, wordsInUse }) {
    const [word, setWord] = useState("");
    const [results, setResults] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleFindWord = () => {
        if (!word.trim()) {
            return;
        }

        setError(null);
        setResults([]);
        setLoading(true);
        Logger.log("wordsInUse", wordsInUse?.split("\n"));

        DatamuseService.wildcardSearch(word)
            .then((r) => {
                Logger.log(r);
                setResults(r.filter(word => !wordsInUse?.split("\n").includes(word.word)));
                setLoading(false);
            })
            .catch((err) => {
                Logger.error("Error in wildcard search:", err);
                setLoading(false);
                
                // Check if it's a 504 Gateway Timeout error
                if (err.status === 504 || err.message?.includes('504') || err.message?.includes('Gateway Timeout')) {
                    setError("504 Gateway Timeout: The server took too long to respond. Please try again.");
                } else if (err.message?.includes('Network') || err.message?.includes('fetch') || err.message?.includes('Failed to fetch')) {
                    setError("Network error: Unable to connect to the server. Please check your connection and try again.");
                } else if (err.status) {
                    setError(`Error ${err.status}: ${err.statusText || err.message || "An error occurred while searching for words."}`);
                } else {
                    setError(`Error: ${err.message || "An error occurred while searching for words."}`);
                }
            });
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            handleFindWord();
        }
    };

    return (
        <Paper elevation={2} sx={{ p: 2, display: "flex", flexDirection: "column", alignItems: "center", gap: 2, flexGrow: 1, height: "100%" }}>
            <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
                <Typography variant="subtitle1">Wildcard Search</Typography>
                <Tooltip title="ex) t??t, tes? and result of search doesn't include words used in the puzzle">
                    <InfoIcon sx={{ ml: 0.5, fontSize: 16, color: "text.secondary", cursor: "help" }} />
                </Tooltip>
            </Box>
            <TextField
                label="Enter a word"
                value={word}
                onChange={(e) => setWord(e.target.value)}
                sx={{ mb: 1, width: '100%' }}
                size="small"
                onKeyDown={handleKeyDown}
                slotProps={{
                    input: {
                        endAdornment: (
                            <InputAdornment position="end">
                                <Typography variant="caption" color="text.secondary">
                                    {word.length}
                                </Typography>
                            </InputAdornment>
                        ),
                    },
                }}
            />
            {error && (
                <Alert severity="error" sx={{ width: '100%' }}>
                    {error}
                </Alert>
            )}
            {loading && (
                <Typography variant="caption" color="text.secondary">
                    Searching...
                </Typography>
            )}
            {results.length > 0 && (
                <Box sx={{ p: 1,  overflow: 'auto', width: '100%', flexGrow: 1 }}>
                    <List dense>
                        {results.map((result) => (
                            <ListItem
                                key={result.word}
                                disablePadding
                                secondaryAction={
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Typography variant="caption" color="text.secondary" sx={{ mr: 1 }}>
                                            {result.score}
                                        </Typography>
                                        {callback && (
                                            <IconButton edge="end" aria-label="add" size="small" onClick={() => callback(result.word)}>
                                                <AddIcon fontSize="small" />
                                            </IconButton>
                                        )}
                                    </Box>
                                }
                            >
                                <ListItemText
                                    primary={result.word}
                                    primaryTypographyProps={{ variant: 'body2' }}
                                />
                            </ListItem>
                        ))}
                    </List>
                </Box>
            )}
            {results.length === 0 && word && !loading && !error && (
                <Typography variant="caption">No words found for "{word}".</Typography>
            )}
        </Paper>
    );
}

